export default "__VITE_ASSET__DmdswKGj__"